import { clsx, type ClassValue } from 'clsx';

/** Merge Tailwind classes with deduplication via clsx. */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
